import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  inject,
  Output,
  QueryList,
} from '@angular/core';
import { Input } from '@angular/core';
import { TabWrapperContentDirective } from '@shared/directives/tabs-wrapper/tabs-wrapper-content.directive';

export interface ITabsItemWrapper {
  id: number;
  label: string;
  icon?: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-tabs-wrapper',
  templateUrl: 'tabs-wrapper.component.html',
  styleUrls: ['tabs-wrapper.component.scss'],
})
export class TabsWrapperComponent implements AfterContentInit {
  @Input() tabs: ITabsItemWrapper[] = [];
  @Input() activeIndex = 0;
  @Output() activeIndexChange = new EventEmitter<number>();

  @ContentChildren(TabWrapperContentDirective)
  contents!: QueryList<TabWrapperContentDirective>;

  private contentMap = new Map<number, TabWrapperContentDirective>();

  private cdr = inject(ChangeDetectorRef);

  ngAfterContentInit(): void {
    this.contents.forEach((c) => this.contentMap.set(c.id, c));

    console.log(this.tabs);

    this.cdr.detectChanges();
  }

  onTabChange(index: number): void {
    this.activeIndexChange.emit(index);
  }

  templateFor(tabId: number) {
    return this.contentMap.get(tabId)?.template ?? null;
  }
}
